import { useEffect, useRef } from "react";

import { Heading4 } from "@/components/text/Heading4";
import { useConversionIsSubmitting } from "@/lib/zustand/useConversionIsSubmitting";
import { useTutorial } from "@/lib/zustand/useTutorial/useTutorial";

export function SubmittingStep() {
  const nextStep = useTutorial((state) => state.nextStep);
  const isSubmitting = useConversionIsSubmitting((state) => state.isSubmitting);
  const prevIsSubmittingRef = useRef(isSubmitting);

  useEffect(() => {
    // Only advance when transitioning from submitting to not submitting (This is to prevent the tutorial from advancing before the revalidatePath is complete)
    if (prevIsSubmittingRef.current === true && isSubmitting === false) {
      nextStep();
    }
    prevIsSubmittingRef.current = isSubmitting;
  }, [isSubmitting]);

  return (
    <div>
      <Heading4 elementType="h3">Submitting...</Heading4>
    </div>
  );
}
